import React, { useState, useRef, useEffect } from "react";
import { Card, Button, Typography, message } from "antd";
import "./style.css";
import AuthLayout from "../../layouts/auth/AuthLayout";

const { Title, Text } = Typography;

const EnterOtp = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(60);
  const inputsRef = useRef([]);

  /* TIMER */
  useEffect(() => {
    if (timer === 0) return;

    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  /* HANDLE INPUT */
  const handleChange = (value, index) => {
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    // Auto move next
    if (value && index < 5) {
      inputsRef.current[index + 1].focus();
    }
  };

  /* BACKSPACE */
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  /* PASTE OTP */
  const handlePaste = (e) => {
    const pasted = e.clipboardData.getData("text").slice(0, 6);
    if (!/^\d+$/.test(pasted)) return;

    const newOtp = pasted.split("");
    while (newOtp.length < 6) newOtp.push("");
    setOtp(newOtp);

    inputsRef.current[5].focus();
  };

  const handleVerify = () => {
    const otpValue = otp.join("");

    if (otpValue.length < 6) {
      message.error("Please enter complete OTP");
      return;
    }

    message.success("OTP Verified!");
    console.log("OTP:", otpValue);
  };

  const resendOtp = () => {
    setTimer(60);
    message.success("OTP Resent");
  };

  return (
    <AuthLayout title="Welcome Back 👋">

      <Card className="otp-card">
        <Title level={3} className="otp-title">
          Enter OTP
        </Title>

        <Text className="otp-subtitle">
          Enter the 6-digit OTP sent to your mobile
        </Text>

        {/* OTP BOXES */}
        <div className="otp-container" onPaste={handlePaste}>
          {otp.map((digit, index) => (
            <input
              key={index}
              type="text"
              maxLength="1"
              value={digit}
              ref={(el) => (inputsRef.current[index] = el)}
              onChange={(e) => handleChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              className="otp-input"
            />
          ))}
        </div>

        <Button
          type="primary"
          block
          size="large"
          onClick={handleVerify}
        >
          Verify OTP
        </Button>

        {/* TIMER */}
        <div className="otp-footer">
          {timer > 0 ? (
            <Text>Resend OTP in {timer}s</Text>
          ) : (
            <Button type="link" onClick={resendOtp}>
              Resend OTP
            </Button>
          )}
        </div>
      </Card>

    </AuthLayout>
  );
};

export default EnterOtp;
